<div class="modal-header">
  <h4 class="modal-title"
      [innerHtml]="('ADD_LOCATION'|translate)"></h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.close('Close click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="filter-for-list">
  <mat-form-field placement="right" [ngbTooltip]="'SEARCH_INPUT_TOOLTIP' | translate">
    <input matInput (keyup)="applyFilter($event.target.value)" [placeholder]="'SEARCH' | translate">
  </mat-form-field>
  <mat-slide-toggle style="padding-top: 25px; padding-left: 50px;"
                    (click)="toggleActive()">{{getSlideToggleText() | translate}}</mat-slide-toggle>
  <button type="button" class="btn top-list-tools"
          (click)="addAllLocations()" placement="left"
          [ngbTooltip]="'ADD_ALL_LOCATIONS_TOOLTIP' | translate">
    <fa-icon [icon]="faPlus"></fa-icon>
    {{'ADD_ALL_LOCATIONS'|translate}}
  </button>
  <br clear="both"/>
</div>
<app-progressbar *ngIf="showSpinner===true"></app-progressbar>
<table mat-table [dataSource]="locations" matSort class="table-striped" style="width:100%">

  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ID'|translate}}</th>
    <td mat-cell *matCellDef="let location"> {{location.id}}</td>
  </ng-container>

  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'NAME'|translate}}</th>
    <td mat-cell *matCellDef="let location"><b>{{location.name}}</b>
    </td>
  </ng-container>

  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef>{{'ACTIONS'|translate}}</th>
    <td mat-cell *matCellDef="let location">

      <mat-icon style="color:green;cursor:pointer" (click)="addLocationToAlarm(location)"
                matTooltipPosition="right"
                [matTooltip]="'CREATE_ICON_TOOLTIP'|translate">check_circle
      </mat-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'ACTIVE'|translate}}</th>
    <td mat-cell *matCellDef="let location">
      <fa-icon *ngIf="location.active === true" [icon]="faSmile" style="color:green;font-size: 25px;"></fa-icon>
      <fa-icon *ngIf="location.active === false" [icon]="faSadTear" style="color:red;font-size: 25px;"></fa-icon>
    </td>
  </ng-container>


  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>

<mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons [pageSize]="5"></mat-paginator>


<div class="modal-footer">

  <button type="button" class="btn btn-light" (click)="activeModal.close('Close click')"
          [innerHTML]="'CLOSE' | translate">Close
  </button>
</div>
